import { getSdkInstance } from 'matrix-requirements-sdk/client';

export const sdkInstance = getSdkInstance();
